import HTTP from "../http";

const createCancellationTicket = async (orderId, reason, refundInfo = null) => {
  let payload = {
    order_id: orderId,
    reason: reason,
    should_refund: Boolean(refundInfo)
  };

  if (refundInfo) {
    payload = {
      ...payload,
      refund_data: {
        bank: refundInfo.bank,
        agency: refundInfo.agency,
        account: refundInfo.account,
        account_type: refundInfo.accountType
      }
    };
  }

  try {
    return await HTTP.normal.post(
      "/tickets/order-cancellation-ticket",
      payload
    );
  } catch (e) {
    console.log(e);
  }
};

const createRescheduleTicket = async (orderId, reason, rescheduleInfo) => {
  const payload = {
    order_id: orderId,
    reason: reason,
    reschedule_data: {
      date: rescheduleInfo.date,
      initial_hour: rescheduleInfo.initialHour,
      reschedule_option: rescheduleInfo.type
    }
  };

  try {
    return await HTTP.normal.post("/tickets/order-rebooking-ticket", payload);
  } catch (e) {
    console.log(e);
  }
};

const createNoShowInOrderTicket = async () => {
  const payload = {
    question:
      "O profissional da minha limpeza ainda não chegou, ele está a caminho?",
    topic: "general"
  };

  try {
    return await HTTP.normal.post("/tickets/general-question-ticket", payload);
  } catch (e) {
    console.log(e);
  }
};

export default {
  createCancellationTicket,
  createRescheduleTicket,
  createNoShowInOrderTicket
};



// WEBPACK FOOTER //
// ./src/api/modules/support.js